export const name = "RANGE_END";
export const summary = `Gets the upper bound of a range.`;
export const reference = `
## RANGE_END

Gets the upper bound of a range.

\`\`\`
RANGE_END(range_to_check)
\`\`\`

### Description

Gets the upper bound of a range.


### Definitions

- \`range_to_check\`: The \`RANGE<T>\` value.


### Details

Returns \`NULL\` if the upper bound in \`range_value\` is \`UNBOUNDED\`.

Returns \`NULL\` if \`range_to_check\` is \`NULL\`.


### Return type

\`T\` in \`range_value\`


### Examples

In the following query, the upper bound of the range is retrieved:



\`\`\`
SELECT RANGE_END(RANGE<DATE> '[2022-12-01, 2022-12-31)') AS results;

/*------------+
 | results |
 +------------+
 | 2022-12-31 |
 +------------*/
\`\`\`

In the following query, the upper bound of the range is unbounded, so\`NULL\` is returned:



\`\`\`
SELECT RANGE_END(RANGE<DATE> '[2022-12-01, UNBOUNDED)') AS results;

/*------------+
 | results |
 +------------+
 | NULL |
 +------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/range-functions
`;
